import { fork, select } from 'redux-saga/effects';

import { SubmitStakePayload } from '../staking/types';
import type { SagaIterator } from '@redux-saga/types';

import { SubmitStakeType } from '../../constants';
import { RecordOfStakeTypeAmountType } from '../../records';
import { selectMatches } from '../../selectors/entries';
import { selectAmountStakeType } from '../../selectors/stakeTypes';
import {
  selectExpressFreeBet,
  selectExpressMatchPrices,
} from '../../selectors/stakeTypes/express';
import { EntriesBets, EntriesMatches } from '../../types/entries';
import { ExpressMatchPrices } from '../../types/stakeTypes/express';
import { submitStake } from '../staking';

// ---

export default function* processExpress(entries: EntriesBets): SagaIterator {
  const amount: RecordOfStakeTypeAmountType = yield select(selectAmountStakeType);

  if (Number.isNaN(amount.numeric)) {
    console.error('processExpress -> express amount value is not a number');
    return;
  }

  const freeBet = yield select(selectExpressFreeBet);
  const prices: ExpressMatchPrices = yield select(selectExpressMatchPrices);
  const matches: EntriesMatches = yield select(selectMatches);

  const payloadBets = entries.reduce((acc, entry) => {
    acc.push({
      id: entry.entity.id,
      matchId: entry.entity.matchId,
      price: entry.price,
    });

    return acc;
  }, [] as SubmitStakePayload['bets']);

  const payload: SubmitStakePayload = {
    type: SubmitStakeType.EXPRESS,
    bets: payloadBets,
    matchPrices: prices.reduce((acc, value, matchId) => {
      const match = matches.get(matchId);

      if (!match) {
        return acc;
      }

      const isExpressInsideMatch = match.betIds.size > 1;

      let price = value.entryPrice;

      if (!isExpressInsideMatch) {
        const betId: number = match.betIds.first();
        const entryPrice = betId && entries.get(betId)?.price;

        if (entryPrice !== undefined) {
          price = entryPrice;
        }
      }

      return ({
        ...acc,
        [matchId]: price,
      });
    }, {}),
    amount: amount.numeric,
  };

  if (freeBet) {
    payload.freeBetId = freeBet.id;
  }

  yield fork(submitStake, payload);
}
